import { Switch, Space } from 'antd';
import { AppButton } from 'shared/UI/UIKit/Button';
import { AppFlex } from 'shared/UI/UIKit/Flex';
import { AppShareIcon } from 'shared/UI/UIKit/icons/Share';
import { AppTablePlusIcon } from 'shared/UI/UIKit/icons/TablePlus';
import { AppEditIcon } from 'shared/UI/UIKit/icons/Edit';
import { AppModal } from 'shared/UI/UIKit/Modal';
import { ScheduleFilters } from '../../ScheduleFilters';
import { useToolbar } from '../model';
import styles from './styles.module.scss';

interface ToolbarProps {
  scheduleProcessing: boolean;
  setRefineModalOpen: (open: boolean) => void;
}

export const Toolbar = ({ scheduleProcessing, setRefineModalOpen }: ToolbarProps) => {
  const {
    state: { coloredLessons, editMode, resetFiltersModalOpen },
    methods: {
      handleToggleColoredLessons,
      handleDownloadSchedule,
      handleEnterEditMode,
      handleConfirmResetFiltersAndEnterEditMode,
      handleCloseResetFiltersModal,
    },
  } = useToolbar();

  return (
    <>
      <AppFlex direction="row" justifyContent="space-between" unit="16" alignItems="center">
        {!editMode && <ScheduleFilters />}
        <AppFlex direction="row" justifyContent="space-between" unit="16" alignItems="center">
          <span>Цветовая схема</span>
          <Switch checked={coloredLessons} onChange={handleToggleColoredLessons} />
          {!editMode && (
            <Space direction="horizontal" size="small">
              <AppButton
                className={styles.controlsButton}
                type="outline"
                onClick={handleDownloadSchedule}
                disabled={scheduleProcessing || !!editMode}
                icon={<AppShareIcon />}
              >
                Экспорт
              </AppButton>
              <AppButton
                className={styles.controlsButton}
                type="outline"
                onClick={handleEnterEditMode}
                disabled={scheduleProcessing || !!editMode}
                icon={<AppEditIcon className={styles.editIcon} />}
              >
                Редактировать
              </AppButton>
              <AppButton
                type="primary"
                onClick={() => setRefineModalOpen(true)}
                disabled={scheduleProcessing || !!editMode}
                className={styles.controlsButton}
                icon={<AppTablePlusIcon />}
              >
                Достроить
              </AppButton>
            </Space>
          )}
        </AppFlex>
      </AppFlex>
      <AppModal
        visible={resetFiltersModalOpen}
        onCancel={handleCloseResetFiltersModal}
        title="Сбросить фильтры?"
        content="Для редактирования необходимо показать полное расписание. Текущие фильтры будут сброшены."
        footer={
          <Space>
            <AppButton type="outline" onClick={handleCloseResetFiltersModal}>
              Отмена
            </AppButton>
            <AppButton type="primary" onClick={handleConfirmResetFiltersAndEnterEditMode}>
              Сбросить и редактировать
            </AppButton>
          </Space>
        }
      />
    </>
  );
};
